module.exports = __webpack_public_path__ + "static/media/honor5.20786e10.jpg";